import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

const HorarioMaisAtivo = ({ visitas }) => {
  // Agrupar por hora do dia
  const contagemPorHora = Array(24).fill(0); // de 0h a 23h

  visitas.forEach((v) => {
    const hora = new Date(v.createdAt).getHours();
    contagemPorHora[hora]++;
  });

  const dados = contagemPorHora.map((total, hora) => ({
    hora: `${hora}h`,
    total,
  }));

  return (
    <div className="bg-white rounded-2xl my-6 shadow p-4">
      <h3 className="text-sm font-semibold text-gray-600 mb-3">
        Horário mais ativo dos visitantes
      </h3>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={dados}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="hora" fontSize={12} />
          <YAxis allowDecimals={false} fontSize={12} />
          <Tooltip formatter={(v) => [`${v} visita${v !== 1 ? "s" : ""}`, "Total"]} />
          <Bar dataKey="total" fill="#6366F1" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HorarioMaisAtivo;
